import { render } from "./ViewLogbooks.vue?vue&type=template&id=498a2d80&scoped=true"
import script from "./ViewLogbooks.vue?vue&type=script&lang=js"
export * from "./ViewLogbooks.vue?vue&type=script&lang=js"

import "./ViewLogbooks.vue?vue&type=style&index=0&id=498a2d80&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498a2d80"]])

export default __exports__